import { createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 17 14"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("path", { d: "m2.378 9.9 5.139-4.627L2.377.645.69 2.205l3.4 3.042v.051L.69 8.341zm14.19 3.299V11H8.591v2.199z" }, null, -1)
  ]));
}
const programmingLanguageShell = { render };
export {
  programmingLanguageShell as default,
  render
};
//# sourceMappingURL=programming-language-shell.svg.js.map
